
const digest = '6fc99e553ffa72cf4cf05fe7235c372e9434449ff670566023a3e947159d651a';
const classes = {"buttonWrapper":"_buttonWrapper_131er_1"};
const css = `._buttonWrapper_131er_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  